var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgFavoriteBorderFilled = function SvgFavoriteBorderFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7501 2.5C12.3001 2.5 10.9084 3.175 10.0001 4.24167C9.09175 3.175 7.70008 2.5 6.25008 2.5C3.68341 2.5 1.66675 4.51667 1.66675 7.08333C1.66675 10.2333 4.50008 12.8 8.79175 16.7L10.0001 17.7917L11.2084 16.6917C15.5001 12.8 18.3334 10.2333 18.3334 7.08333C18.3334 4.51667 16.3167 2.5 13.7501 2.5ZM10.0834 15.4583L10.0001 15.5417L9.91675 15.4583C5.95008 11.8667 3.33341 9.49167 3.33341 7.08333C3.33341 5.41667 4.58341 4.16667 6.25008 4.16667C7.53341 4.16667 8.78341 4.99167 9.22508 6.13333H10.7834C11.2167 4.99167 12.4667 4.16667 13.7501 4.16667C15.4167 4.16667 16.6667 5.41667 16.6667 7.08333C16.6667 9.49167 14.0501 11.8667 10.0834 15.4583Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgFavoriteBorderFilled);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/favorite-border-filled.7c6d93943778f628334cac0edb92396e.svg";